
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  useSEO({
    title: 'S&L Contractors of Alabama | Home Improvement & Remodeling Mobile AL',
    description:
      'S&L Contractors of Alabama provides professional home improvement, remodeling, and repair services in Mobile & Baldwin Counties AL. Licensed, insured, 20+ years experience. Call 251-348-8514 for free estimates.',
    keywords:
      'home improvement Mobile AL, remodeling contractor Baldwin County, residential contractor Alabama, home repair Mobile County, kitchen remodeling Daphne AL',
    canonical: '/',
    ogType: 'website',
    schemas: [
      {
        '@context': 'https://schema.org',
        '@type': 'GeneralContractor',
        '@id': 'https://www.slcontractorsofal.com/#organization',
        name: 'S&L Contractors of Alabama, Inc.',
        image: 'https://www.slcontractorsofal.com/images/hero-flyer.png',
        url: 'https://www.slcontractorsofal.com',
        telephone: ['+1-251-348-8514', '+1-251-454-1737'],
        email: 'SL.Contractors.AL@gmail.com',
        description:
          'Professional home improvement, remodeling, and repair services in Mobile & Baldwin Counties, Alabama. Over 20 years of experience.',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Mobile',
          addressRegion: 'AL',
          postalCode: '36609',
          addressCountry: 'US',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 30.6954,
          longitude: -88.0399,
        },
        areaServed: [
          { '@type': 'City', name: 'Mobile', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Daphne', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Fairhope', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Spanish Fort', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Gulf Shores', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Orange Beach', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Foley', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Saraland', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Semmes', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Theodore', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'City', name: 'Bay Minette', containedInPlace: { '@type': 'State', name: 'Alabama' } },
          { '@type': 'AdministrativeArea', name: 'Baldwin County' },
          { '@type': 'AdministrativeArea', name: 'Mobile County' },
        ],
        priceRange: '$$',
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ],
            opens: '08:00',
            closes: '20:00',
          },
        ],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          bestRating: '5',
          worstRating: '1',
          reviewCount: '3',
          ratingCount: '3',
        },
        review: [
          {
            '@type': 'Review',
            author: { '@type': 'Person', name: 'MaKail Dezauche' },
            reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
            reviewBody:
              'Shane was beyond professional. He cleaned up behind himself, produced amazing quality work, and worked in a very timely manner! I will never choose another contractor! Thank you!',
            datePublished: '2024-11-07',
          },
          {
            '@type': 'Review',
            author: { '@type': 'Person', name: 'Michelle Farrell' },
            reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
            reviewBody:
              'Can not say enough good things about this company! The wide range of skill and knowledge he has is hard to find. Reliable, trustworthy, professional, and great communication.',
            datePublished: '2024-10-15',
          },
          {
            '@type': 'Review',
            author: { '@type': 'Person', name: 'Jill Vance Andrews' },
            reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
            reviewBody:
              'Shane did a great job repairing the eaves and painting all of the exterior trim on our home!',
            datePublished: '2024-10-01',
          },
        ],
        sameAs: ['https://www.facebook.com/profile.php?id=61551840254912'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'S&L Contractors of Alabama',
        url: 'https://www.slcontractorsofal.com',
        publisher: {
          '@type': 'GeneralContractor',
          '@id': 'https://www.slcontractorsofal.com/#organization',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What areas does S&L Contractors serve in Alabama?',
            acceptedAnswer: {
              '@type': 'Answer',
              text:
                'S&L Contractors serves homeowners across Baldwin County and Mobile County, Alabama, including Mobile, Daphne, Fairhope, Spanish Fort, Gulf Shores, Orange Beach, Foley, Saraland, Semmes, Theodore, Bay Minette, and Prichard.',
            },
          },
          {
            '@type': 'Question',
            name: 'What home improvement services does S&L Contractors offer?',
            acceptedAnswer: {
              '@type': 'Answer',
              text:
                'We offer a full range of home improvement services including interior remodeling (kitchen, bathroom, flooring, painting), exterior projects (siding, decks, fences, painting), handyman services, and professional contracting for additions, conversions, and storm damage repair.',
            },
          },
          {
            '@type': 'Question',
            name: 'Does S&L Contractors offer free estimates?',
            acceptedAnswer: {
              '@type': 'Answer',
              text:
                'Yes! S&L Contractors provides free, no-obligation estimates for all home improvement projects. Call us at 251-348-8514 or visit our contact page to request your free quote.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is S&L Contractors licensed and insured?',
            acceptedAnswer: {
              '@type': 'Answer',
              text:
                'Yes, S&L Contractors of Alabama is fully licensed and insured with over 20 years of experience in residential contracting and home improvement services.',
            },
          },
        ],
      },
    ],
  });

  const advantages = [
    {
      number: '1',
      title: 'Personalized Services',
      description:
        'Our home improvement services are tailored to all your needs to achieve the desired results for your Mobile AL home.',
    },
    {
      number: '2',
      title: 'Wide Range of Skills',
      description:
        'We provide professional interior and exterior remodeling services to accommodate each individual customer in Baldwin & Mobile Counties.',
    },
    {
      number: '3',
      title: 'Quality Care',
      description:
        'We strive to offer the best residential contractor service in terms of quality, speed, and cost throughout Alabama.',
    },
  ];

  return (
    <div className="min-h-screen bg-[#f5f0e6]">
      <Navbar />

      {/* Hero Section */}
      <header className="relative min-h-screen flex items-center pt-20 px-4">
        <div className="max-w-7xl mx-auto w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left space-y-6">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                <a href="/" className="no-underline text-inherit">
                  S&L Contractors of Alabama, Inc.
                </a>
              </h1>

              <p className="text-base text-gray-700 max-w-2xl leading-relaxed">
                S&L Contractors of Alabama, Inc. is a{' '}
                <strong>residential contractor</strong> with over 20 years of
                experience offering{' '}
                <strong>home improvement</strong>, remodeling &amp; repair
                services in <strong>Baldwin &amp; Mobile Counties</strong>. We
                specialize in helping you get the most value out of your home!!
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mt-8">
                Work Done With Excellence &amp; Integrity
              </h2>

              <p className="text-sm text-gray-600 italic">
                &quot;And whatever you do, work heartily, as for the Lord and
                not for men&quot;<br />
                -Colossians 3:23
              </p>

              <div className="pt-6 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="/services"
                  className="text-white px-8 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                  style={{ backgroundColor: '#1e3a5f' }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#152a45')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#1e3a5f')
                  }
                >
                  Explore Services
                </a>
                <a
                  href="/contact"
                  className="border-2 border-sky-500 text-sky-600 hover:bg-sky-500 hover:text-white px-8 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  Get Free Quote
                </a>
                <a
                  href="tel:251-348-8514"
                  className="text-white px-8 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                  style={{ backgroundColor: '#1e3a5f' }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#152a45')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#1e3a5f')
                  }
                >
                  <i className="ri-phone-line mr-2"></i>
                  Book a Call
                </a>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="w-full h-[500px] rounded-br-[80px] overflow-hidden">
                <img
                  src="/images/hero-flyer.png"
                  alt="S&L Contractors of Alabama home improvement and remodeling services in Mobile AL"
                  title="S&L Contractors - Home Improvement Mobile AL"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Advantages Section */}
      <section
        className="py-20 px-4 bg-[#ebe5d9]"
        aria-label="Why choose S&L Contractors"
      >
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16">
            Why Choose Us
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {advantages.map((advantage) => (
              <article
                key={advantage.number}
                className="text-center space-y-4"
              >
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-full mx-auto"
                  style={{ backgroundColor: '#1e3a5f' }}
                >
                  <span className="text-2xl font-bold text-white">
                    {advantage.number}
                  </span>
                </div>
                <h4 className="text-xl font-semibold text-gray-900">
                  <a
                    href="/services"
                    className="no-underline text-inherit hover:text-sky-600 transition-colors"
                  >
                    {advantage.title}
                  </a>
                </h4>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {advantage.description}
                </p>
              </article>
            ))}
          </div>

          {/* BBB Accredited Business Badge */}
          <div className="mt-16 flex flex-col items-center">
            <a
              href="https://www.bbb.org"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="cursor-pointer hover:opacity-90 transition-opacity duration-300"
            >
              <div className="w-48 h-auto">
                <img
                  src="/images/bbb-badge.png"
                  alt="BBB Accredited Business badge - S&L Contractors of Alabama"
                  title="Better Business Bureau Accredited Business"
                  className="w-full h-auto object-contain"
                />
              </div>
            </a>
            <p className="text-sm text-gray-600 mt-3 font-medium">
              BBB Accredited Business
            </p>
          </div>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section
        className="py-20 px-4 bg-[#ebe5d9]"
        aria-label="Customer reviews"
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              What Our Customers Say
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Don&apos;t just take our word for it. Here&apos;s what homeowners
              in <strong>Baldwin &amp; Mobile Counties</strong> have to say
              about our <strong>home improvement</strong> work.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <article className="bg-[#faf7f2] rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sky-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                &quot;Shane was beyond professional. He cleaned up behind
                himself, produced amazing quality work, and worked in a very
                timely manner! I will never choose another contractor! Thank
                you!&quot;
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-sky-600 font-semibold text-lg">
                    MD
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">
                    MaKail Dezauche
                  </p>
                  <p className="text-sm text-gray-500">Facebook Review</p>
                </div>
              </div>
            </article>

            {/* Testimonial 2 */}
            <article className="bg-[#faf7f2] rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sky-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                &quot;Can not say enough good things about this company! The
                wide range of skill and knowledge he has is hard to find.
                Reliable, trustworthy, professional, and great communication.&quot;
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-sky-600 font-semibold text-lg">
                    MF
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">
                    Michelle Farrell
                  </p>
                  <p className="text-sm text-gray-500">Facebook Review</p>
                </div>
              </div>
            </article>

            {/* Testimonial 3 */}
            <article className="bg-[#faf7f2] rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sky-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                &quot;Shane did a great job repairing the eaves and painting all
                of the exterior trim on our home!&quot;
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-sky-600 font-semibold text-lg">
                    JA
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">
                    Jill Vance Andrews
                  </p>
                  <p className="text-sm text-gray-500">Facebook Review</p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Service Area Coverage Map */}
      <section
        className="py-20 px-4 bg-[#f5f0e6]"
        aria-label="Service area coverage"
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Area
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Proudly serving homeowners across <strong>Baldwin County</strong>{' '}
              and <strong>Mobile County</strong>, Alabama. From Daphne to Mobile
              and everywhere in between, we bring quality{' '}
              <strong>home improvement</strong> to your doorstep.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-2 w-full h-[450px] rounded-lg overflow-hidden shadow-md">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d440796.0742890498!2d-87.85!3d30.65!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="S&L Contractors Service Area - Baldwin and Mobile Counties Alabama"
                aria-label="Google Map showing S&L Contractors service area in Baldwin and Mobile Counties"
              ></iframe>
            </div>

            <div className="bg-[#ebe5d9] rounded-lg p-8 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-6 flex items-center">
                <i className="ri-map-pin-2-fill text-sky-500 mr-2 text-xl"></i>
                Areas We Serve
              </h3>
              <div className="space-y-3">
                {[
                  'Mobile, AL',
                  'Daphne, AL',
                  'Fairhope, AL',
                  'Spanish Fort, AL',
                  'Saraland, AL',
                  'Prichard, AL',
                  'Semmes, AL',
                  'Theodore, AL',
                  'Foley, AL',
                  'Gulf Shores, AL',
                  'Orange Beach, AL',
                  'Bay Minette, AL',
                ].map((area) => (
                  <div key={area} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-sky-500 mr-3 text-lg"></i>
                    <span className="text-sm font-medium">{area}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-[#ddd6c6]">
                <p className="text-sm text-gray-600 mb-4">
                  Don&apos;t see your area? Give us a call — we may still be able
                  to help!
                </p>
                <a
                  href="/contact"
                  className="inline-flex items-center text-white px-5 py-2.5 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                  style={{ backgroundColor: '#1e3a5f' }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#152a45')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#1e3a5f')
                  }
                >
                  <i className="ri-phone-line mr-2"></i>
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted Service Section */}
      <section
        className="py-20 px-4 bg-[#1e3a5f]"
        aria-label="Trusted contractor services"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-white mb-6">
                Trusted Home Improvement Service in Baldwin &amp; Mobile Counties
              </h2>
              <p className="text-gray-300 leading-relaxed mb-8">
                With over 20 years of experience, S&amp;L Contractors of Alabama
                has built a reputation for quality workmanship and exceptional
                customer service. We treat every home as if it were our own,
                delivering{' '}
                <strong className="text-white">remodeling</strong> and{' '}
                <strong className="text-white">repair services</strong> you can
                count on.
              </p>
              <div className="space-y-4">
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-double-line text-sky-400 mr-3 text-xl"></i>
                  <span>Licensed &amp; Insured</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-double-line text-sky-400 mr-3 text-xl"></i>
                  <span>Free Estimates</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-double-line text-sky-400 mr-3 text-xl"></i>
                  <span>Quality Guaranteed</span>
                </div>
              </div>
            </div>
            <div className="text-center lg:text-left">
              <div className="bg-white/10 rounded-lg p-8">
                <h3 className="text-xl font-semibold text-white mb-4">
                  Contact Us Today
                </h3>
                <address className="not-italic space-y-3">
                  <p className="text-gray-300">
                    <i className="ri-phone-line mr-2"></i>
                    <a
                      href="tel:251-348-8514"
                      className="text-gray-300 hover:text-white cursor-pointer"
                    >
                      251-348-8514
                    </a>
                  </p>
                  <p className="text-gray-300">
                    <i className="ri-phone-line mr-2"></i>
                    <a
                      href="tel:251-454-1737"
                      className="text-gray-300 hover:text-white cursor-pointer"
                    >
                      251-454-1737
                    </a>
                  </p>
                  <p className="text-gray-300">
                    <i className="ri-mail-line mr-2"></i>
                    <a
                      href="mailto:SL.Contractors.AL@gmail.com"
                      className="text-gray-300 hover:text-white cursor-pointer"
                    >
                      SL.Contractors.AL@gmail.com
                    </a>
                  </p>
                </address>
                <a
                  href="/contact"
                  className="inline-block mt-6 bg-sky-500 hover:bg-sky-600 text-white px-6 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer"
                >
                  Request a Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section
        className="py-20 px-4 bg-[#f5f0e6]"
        aria-label="Frequently asked questions"
      >
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="space-y-6">
            <article className="bg-[#faf7f2] rounded-lg p-6 shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                <a
                  href="/services"
                  className="no-underline text-inherit hover:text-sky-600 transition-colors"
                >
                  What areas does S&amp;L Contractors serve in Alabama?
                </a>
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                We serve homeowners across Baldwin County and Mobile County,
                Alabama, including Mobile, Daphne, Fairhope, Spanish Fort,
                Gulf Shores, Orange Beach, Foley, Saraland, Semmes, Theodore,
                Bay Minette, and Prichard.
              </p>
            </article>
            <article className="bg-[#faf7f2] rounded-lg p-6 shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                <a
                  href="/services"
                  className="no-underline text-inherit hover:text-sky-600 transition-colors"
                >
                  What home improvement services does S&amp;L Contractors
                  offer?
                </a>
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                We offer a full range of home improvement services including
                interior remodeling (kitchen, bathroom, flooring, painting),
                exterior projects (siding, decks, fences, painting), handyman
                services, and professional contracting for additions,
                conversions, and storm damage repair.
              </p>
            </article>
            <article className="bg-[#faf7f2] rounded-lg p-6 shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                <a
                  href="/contact"
                  className="no-underline text-inherit hover:text-sky-600 transition-colors"
                >
                  Does S&amp;L Contractors offer free estimates?
                </a>
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Yes! S&amp;L Contractors provides free, no-obligation estimates
                for all home improvement projects. Call us at 251-348-8514 or
                visit our contact page to request your free quote.
              </p>
            </article>
            <article className="bg-[#faf7f2] rounded-lg p-6 shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                <a
                  href="/services"
                  className="no-underline text-inherit hover:text-sky-600 transition-colors"
                >
                  Is S&amp;L Contractors licensed and insured?
                </a>
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Yes, S&amp;L Contractors of Alabama is fully licensed and
                insured with over 20 years of experience in residential
                contracting and home improvement services.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="py-20 px-4 bg-[#f5f0e6]"
        aria-label="Call to action"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-gray-900 leading-tight">
                Transform Your Home with S&amp;L Contractors
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Transform your home with our experienced contractors who
                specialize in interior and exterior <strong>remodeling</strong>,
                repair services, and{' '}
                <strong>home improvement</strong> in{' '}
                <strong>Mobile &amp; Baldwin Counties</strong>, Alabama.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="/gallery"
                  className="border-2 border-sky-500 text-sky-600 hover:bg-sky-500 hover:text-white px-8 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  View Our Work
                </a>
                <a
                  href="/contact"
                  className="text-white px-8 py-3 rounded-md font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                  style={{ backgroundColor: '#1e3a5f' }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#152a45')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#1e3a5f')
                  }
                >
                  Get Free Estimate
                </a>
              </div>
            </div>
            <div className="w-full h-[400px] rounded-lg overflow-hidden">
              <img
                src="/images/hero-flyer.png"
                alt="Professional home remodeling and improvement services by S&L Contractors in Mobile Alabama"
                title="S&L Contractors - Remodeling Services Baldwin County AL"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
